import { FormattedMessage } from 'react-intl';
import { CollectionPointWithI18nKey } from '../../../../types/collectionPoints';
import { getAssetUrl } from '../../../../utils/config';
import './style.scss';

export type LocationItemProps = {
  location: CollectionPointWithI18nKey;
  onClick: () => void;
};

const LocationItem = ({ location, onClick }: LocationItemProps) => {
  const {
    displayData: { description, address, distanceToSearchAddress },
    i18nKey,
  } = location;
  const distanceInKm = Math.round((distanceToSearchAddress / 1000) * 100) / 100;

  return (
    <div className="location-item" onClick={onClick}>
      <div className="location-item__text-wrapper">
        <div
          className="location-item__icon"
          style={{ backgroundImage: `url(${getAssetUrl(`collectionPoints/squares/${i18nKey}.svg`)})` }}
        />
        <div className="location-item__text">
          <p className="location-item__title">
            {description || <FormattedMessage id={`shipping.collectionPoint.types.${i18nKey}`} />}
          </p>
          <p className="location-item__address">
            {address.streetHouseNumber}, {address.zipCode} {address.city}
          </p>
        </div>
      </div>
      <div className="location-item__distance">
        <img src={getAssetUrl('collectionPoints/location.svg')} />
        <p>
          <FormattedMessage id="shipping.collectionPoint.location.distance" values={{ distanceInKm }} />
        </p>
      </div>
    </div>
  );
};

export default LocationItem;
